/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'enroll-info': {
    width: 15.2,
    height: 16,
    viewBox: '0 0 15.2 16',
    data: '<path pid="0" d="M7.6 6A1.6 1.6 0 106 4.4 1.6 1.6 0 007.6 6zm5.2-6H2.4A2.394 2.394 0 000 2.4v11.21a2.4 2.4 0 002.4 2.4h10.4a2.394 2.394 0 002.4-2.4V2.395a2.4 2.4 0 00-2.4-2.4zM3.674 8.043a4.838 4.838 0 012.422-1.787 2.4 2.4 0 113.022-.013 4.811 4.811 0 012.639 2.076.4.4 0 01-.683.418 4.041 4.041 0 00-6.748-.231.4.4 0 11-.652-.462zM3.937 9.6h3.662a.4.4 0 010 .8H3.938a.4.4 0 010-.8zm7.854 3.2H3.938a.4.4 0 010-.8h7.854a.4.4 0 010 .8z" _fill="#212121"/>'
  }
})
